import React, { useState } from 'react';
import './SecurityPanel.css';

function SecurityPanel({ security, onUpdate, onRemove, onMoveUp, onMoveDown }) {
  const [confirmRemove, setConfirmRemove] = useState(false);

  const handleRemoveClick = () => {
    if (confirmRemove) {
      onRemove();
      setConfirmRemove(false);
    } else {
      setConfirmRemove(true);
    }
  };

  const handleCancelRemove = () => setConfirmRemove(false);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let parsed = type === 'number' ? parseFloat(value) : value;

    if (type === 'number' && isNaN(parsed)) parsed = 0;
    if (name === 'quantity' && parsed < 0) parsed = 0;
    if (name === 'strikePrice' && parsed < 0) parsed = 0;
    if (name === 'faceValue' && parsed < 0) parsed = 0;
    if (name === 'purchasePrice' && parsed < 0) parsed = 0;
    if (name === 'premium' && parsed < 0) parsed = 0;

    onUpdate({ ...security, [name]: parsed });
  };

  const isOption = security.type === 'Call' || security.type === 'Put';
  const posLabel = security.position === 'long' ? 'Long' : 'Short';
  const typeColor = {
    Stock: 'stock',
    Bond: 'bond',
    Call: 'call',
    Put: 'put'
  }[security.type] || 'stock';

  const idPrefix = `sec-${security.id}`;

  return (
    <div className={`security-panel security-panel--${typeColor}`} role="group" aria-labelledby={`${idPrefix}-heading`}>
      <div className="security-panel-header">
        <h3 id={`${idPrefix}-heading`} className="security-panel-heading">
          <span className={`type-badge type-badge--${typeColor}`}>{security.type}</span>
          {posLabel}
        </h3>
        <div className="panel-actions">
          {onMoveUp && (
            <button type="button" className="move-btn" onClick={onMoveUp} aria-label="Move up" title="Move up">{'\u2191'}</button>
          )}
          {onMoveDown && (
            <button type="button" className="move-btn" onClick={onMoveDown} aria-label="Move down" title="Move down">{'\u2193'}</button>
          )}
          {confirmRemove ? (
            <>
              <button type="button" className="remove-confirm-btn remove-yes" onClick={handleRemoveClick}>Remove</button>
              <button type="button" className="remove-confirm-btn remove-cancel" onClick={handleCancelRemove}>Cancel</button>
            </>
          ) : (
            <button type="button" className="remove-btn" onClick={handleRemoveClick} aria-label="Remove">{'\u2715'}</button>
          )}
        </div>
      </div>

      <div className="form-row">
        <div className="form-group form-group--half">
          <label htmlFor={`${idPrefix}-type`}>Type</label>
          <select id={`${idPrefix}-type`} name="type" value={security.type} onChange={handleChange}>
            <option value="Stock">Stock</option>
            <option value="Bond">Bond</option>
            <option value="Call">Call</option>
            <option value="Put">Put</option>
          </select>
        </div>
        <div className="form-group form-group--half">
          <label htmlFor={`${idPrefix}-position`}>Position</label>
          <select id={`${idPrefix}-position`} name="position" value={security.position} onChange={handleChange}>
            <option value="long">Long</option>
            <option value="short">Short</option>
          </select>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group form-group--half">
          <label htmlFor={`${idPrefix}-quantity`}>Quantity</label>
          <input id={`${idPrefix}-quantity`} type="number" name="quantity" value={security.quantity} onChange={handleChange} step="1" min="0" />
        </div>
        {isOption && (
          <div className="form-group form-group--half">
            <label htmlFor={`${idPrefix}-strike`}>Strike</label>
            <input id={`${idPrefix}-strike`} type="number" name="strikePrice" value={security.strikePrice} onChange={handleChange} step="1" min="0" />
          </div>
        )}
        {security.type === 'Stock' && (
          <div className="form-group form-group--half">
            <label htmlFor={`${idPrefix}-purchasePrice`}>Cost Basis</label>
            <input id={`${idPrefix}-purchasePrice`} type="number" name="purchasePrice" value={security.purchasePrice ?? 0} onChange={handleChange} step="1" min="0" />
          </div>
        )}
        {security.type === 'Bond' && (
          <div className="form-group form-group--half">
            <label htmlFor={`${idPrefix}-faceValue`}>Face Value</label>
            <input id={`${idPrefix}-faceValue`} type="number" name="faceValue" value={security.faceValue} onChange={handleChange} step="1" min="0" />
          </div>
        )}
      </div>

      {isOption && (
        <div className="form-row">
          <div className="form-group form-group--full">
            <label htmlFor={`${idPrefix}-premium`}>
              Premium {security.position === 'long' ? '(paid)' : '(received)'}
            </label>
            <input id={`${idPrefix}-premium`} type="number" name="premium" value={security.premium ?? 0} onChange={handleChange} step="0.01" min="0" />
          </div>
        </div>
      )}

      <div className="form-row">
        <div className="form-group form-group--full">
          <label htmlFor={`${idPrefix}-label`}>Label</label>
          <input id={`${idPrefix}-label`} type="text" name="label" value={security.label ?? ''} onChange={handleChange} placeholder="Optional chart label" />
        </div>
      </div>
    </div>
  );
}

export default SecurityPanel;
